import DashboardPage from '@/pages/Dashboard';
import { ROUTES } from './routes.config';
import { Navigate } from 'react-router-dom';
import { AuthGuard } from '@/rtkQuery/features/services/auth';

export const DashboardRoutes = {
  path: ROUTES.DASHBOARD,
  children: [
    { index: true, element: <Navigate to="notifications" replace /> },
    { path: ':tabSlug', element: <AuthGuard><DashboardPage /> </AuthGuard> },
  ],
};
